export default __webpack_public_path__ + "static/media/icon-motor.eb8eb4a4.svg";